import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class OverviewKeys extends MainKeys {
    get place() {
        return Places.overview
    }
}

export default OverviewKeys
